// removed by extract-text-webpack-plugin
module.exports = {"chatBot":"HelpBot__chatBot__2ZRG3"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/HelpBot/HelpBot.css
// module id = 252
// module chunks = 0